import { Component } from '@angular/core';
import { ArticleService } from 'src/app/services/article.service';
import { DiseaseService } from 'src/app/services/disease.service';
import { Article, Disease, Image } from 'shared/types';
import { Page, Section, SubSection } from 'shared/location-enums';
import { PATHS } from 'shared/paths';
import { randomId } from 'shared/utils/random-id';

@Component({
    selector: 'your-medical-team',
    templateUrl: './your-medical-team.component.html',
    styleUrls: ['./your-medical-team.component.scss'],
})
export class YourMedicalTeamComponent {
    public medTeam: Article;
    public pediatric: Article;
    public recommended: Article;
    public articlesDisplayed: Article[] = [];
    public articleImagesPath: string = PATHS.articleImages;
    public prefix = randomId();
    public textHeader = 'Your Health Care Team';
    public isNull = false;

    constructor(diseaseService: DiseaseService, articleService: ArticleService) {
        // This for the body
        this.medTeam = articleService.getArticles(Page.diagnosis, Section.medicalTeam, SubSection.parent, undefined, undefined, this.isNull)[0];
        if (this.medTeam) {
            this.medTeam.bodyText = this.medTeam.bodyText.replace('${DiseaseName}', diseaseService.disease.name);
        }

        this.recommended = articleService.getArticles(Page.diagnosis, Section.medicalTeam, SubSection.taggedSpecialist)[0];
        if (this.recommended) {
            this.recommended.title = this.recommended.title.replace('${DiseaseName}', diseaseService.disease.name);
        }

        const allSpecialistArticles = this.addMissingArticleImages(articleService.getArticles(Page.diagnosis, Section.medicalTeam, SubSection.specialists));
        this.articlesDisplayed = this.getMatchingSpecialistArticles(allSpecialistArticles, diseaseService.disease).sort((a, b) =>
            a.title.localeCompare(b.title, 'en', { sensitivity: 'base' }),
        );

        if (diseaseService?.disease?.tagsSpecialist?.includes('Pediatrics')) {
            const allKAs = articleService.getArticles(Page.diagnosis, Section.medicalTeam, SubSection.parent, undefined, undefined, false);
            this.pediatric = allKAs.filter((a: Article) => a.tags.includes('Pediatrics'))[0];
        }

        // compute if null
        this.isNull = this.articlesDisplayed.length === 0;
    }

    private addMissingArticleImages(articles: Article[]): Article[] {
        return articles.map(article => ({
            ...article,
            images: article.images?.length ? article.images : ([{ url: '', altText: '' }] as Image[]),
        }));
    }

    private getMatchingSpecialistArticles(articles: Article[], disease: Disease): Article[] {
        const diseaseSpecialistTags = disease.tagsSpecialist || [];

        return [...articles]
            .sort((a, b) => (a.order !== undefined ? a.order : Infinity) - (b.order !== undefined ? b.order : Infinity))
            .filter(article => article.allPages || (article.tags && article.tags.some(tag => diseaseSpecialistTags.indexOf(tag) > -1)));
    }
}
